import React from "react";
import { Control, useWatch } from "react-hook-form";
import {
  ReactSelectController,
  Text,
  Grid,
  Divider,
  NumberController,
  TextAreaController,
  SwitchController,
  TextController,
} from "@pushpress/shared-components";
import { EventForm } from "./../CalendarForm.utils";
import {
  reservationsOpenOptions,
  reservationsCloseOptions,
} from "../../Calendar.utils";
import LocationSelect from "../../../../components/controllers/LocationSelect";

type EventSettingsProps = {
  control: Control<EventForm>;
};

const EventSettings = ({ control }: EventSettingsProps) => {
  const [attendanceLimit] = useWatch({
    control,
    name: ["attendanceLimit"],
  });

  return (
    <div className="p-4">
      <Text variant="heading-5" color="wolf-800" className="mt-3" weight="600">
        Reservation settings
      </Text>
      <Text variant="body-md" color="wolf-600">
        Set preferences for when clients can reserve
      </Text>
      <ReactSelectController
        className="mt-4"
        control={control}
        name="reservationsOpen"
        required
        label="Reservations open"
        options={reservationsOpenOptions}
        menuPortalTarget={document.body}
      />
      <ReactSelectController
        control={control}
        name="reservationsClose"
        required
        label="Reservations close"
        options={reservationsCloseOptions}
        menuPortalTarget={document.body}
      />
      <Grid container columnSpacing={0} spacing={2}>
        <Grid item>
          <SwitchController
            className="mt-1"
            label="Attendance limit"
            hideLabel
            control={control}
            name="attendanceLimit.hasAttendanceLimit"
          />
        </Grid>
        <Grid item xs={4}>
          <NumberController
            control={control}
            name="attendanceLimit.number"
            required
            label="Attendance number"
            hideLabel
            disabled={!attendanceLimit?.hasAttendanceLimit}
            min={0}
          />
        </Grid>
      </Grid>
      <Divider vPadding={8} marginRight={-28} />
      <Text variant="heading-5" color="wolf-800" className="mt-3" weight="600">
        Other settings
      </Text>
      <LocationSelect
        className="mt-4"
        control={control}
        name="location"
        label="Location"
        placeholder="— Add location —"
        menuPortalTarget={document.body}
        hideDropdownIndicator
        isClearable
      />
      <TextAreaController
        control={control}
        name="description"
        label="Description"
      />
      <SwitchController
        control={control}
        name="showOnMemberApp"
        label="Publish on member app"
      />
      <TextController
        control={control}
        name="redirectUrl"
        label="Redirect URL"
        helperText="Redirect someone after they complete registration"
        className="mt-4"
      />
    </div>
  );
};

export default EventSettings;
